import { render, staticRenderFns } from "./new_auth_dia.vue?vue&type=template&id=3e5fa78e&scoped=true"
import script from "./new_auth_dia.vue?vue&type=script&lang=js"
export * from "./new_auth_dia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5fa78e",
  null
  
)

export default component.exports